import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function globalAnimation() {
	const sectionsAnimation = () => {
		document.querySelectorAll('section').forEach((section) => {
			gsap.from(section, {
				y: 50,
				opacity: 0,
				duration: 1,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: section,
					start: 'top 90%', // Ativa quando o topo da section está a 90% da viewport
					toggleActions: 'play none none none',
				},
			})
		})
	}

	const porcentageBar = () => {
		gsap.utils.toArray('.progress-wrapper').forEach((wrapper) => {
			const bar = wrapper.querySelector('.progress-bar')
			const label = wrapper.querySelector('.progress-label')

			const barWidth = label.dataset.percent // ex: "100%"
			const labelTarget = parseFloat(label.dataset.percentageLabel) // ex: 300 ou 74.9

			// Animate the progress bar
			gsap.fromTo(
				bar,
				{ width: '0%' },
				{
					width: barWidth,
					scrollTrigger: {
						trigger: wrapper,
						start: 'top 80%',
					},
					duration: 1,
					ease: 'power2.out',
				}
			)

			// Animate the label number with optional comma
			const obj = { val: 0 }
			gsap.to(obj, {
				val: labelTarget,
				scrollTrigger: {
					trigger: wrapper,
					start: 'top 80%',
				},
				duration: 1.2,
				ease: 'power1.out',
				onUpdate: () => {
					const hasDecimal = !Number.isInteger(labelTarget)
					const value = hasDecimal ? obj.val.toFixed(1).replace('.', ',') : Math.round(obj.val).toString()
					label.innerText = `${value}%`
				},
			})
		})
	}

	const textoBrilha = () => {
		document.querySelectorAll('.texto-brilha-gsap').forEach((text) => {
			const rgb = getComputedStyle(text).color // tipo: rgb(255, 0, 0)
			console.log('rgb', rgb)
			// Converte "rgb(255, 0, 0)" para "rgba(255, 0, 0, 0.5)"
			const rgbaStart = rgb.replace(/rgb\((\d+), (\d+), (\d+)\)/, 'rgba($1, $2, $3, 0.5)')

			gsap
				.fromTo(
					text,
					{
						textShadow: `0px 0px 0px ${rgb}`,
						color: rgbaStart,
					},
					{
						textShadow: `0px 0px 3px ${rgb}`,
						color: rgb,
						duration: 1,
						immediateRender: false,
						ease: 'power2.out',
						scrollTrigger: {
							trigger: text,
							start: 'top 90%',
						},
					}
				)
				.repeat(-1)
				.yoyo(true)

			// Agora animar o <span> dentro dele (vermelho)
			const span = text.querySelector('span')
			if (span) {
				const colorSpan = getComputedStyle(span).color
				const rgbaSpan = colorSpan.replace(/rgb\((\d+), (\d+), (\d+)\)/, 'rgba($1, $2, $3, 0.5)')

				gsap.fromTo(
					span,
					{
						textShadow: `0px 0px 0px ${colorSpan}`,
						color: rgbaSpan,
					},
					{
						textShadow: `0px 0px 5px ${colorSpan}`,
						color: colorSpan,
						duration: 1,
						ease: 'power2.out',
						scrollTrigger: {
							trigger: text,
							start: 'top 90%',
						},
						repeat: -1,
						yoyo: true,
					}
				)
			}

			// z
		})
	}

	const shakeOnVisible = () => {
		// const ctaWhatsWrapper = document.querySelector('.cta-whats-wrapper .Button-whatsapp')

		document.addEventListener('DOMContentLoaded', () => {
			// if (window.innerWidth <= 1024) {}
			gsap.utils.toArray('.gsap-shake-on-visible').forEach((btn) => {
				ScrollTrigger.create({
					trigger: btn,
					refreshPriority: 1,
					start: 'top 90%', // Quando o topo do elemento estiver a 90% da altura da viewport
					onEnter: () => {
						gsap.fromTo(
							btn,
							{
								rotation: -5,
							},
							{
								rotation: 5,
								duration: 0.2,
								yoyo: true,
								repeat: 4,
								ease: 'power1.inOut',
								onComplete: () => {
									gsap.set(btn, { rotation: 0 })
								},
							}
						)
					},
				})
			})
		})
	}

	const passosSucessoHome = () => {
		const container = document.querySelector('.animation-wrapper-gsap')
		if (!container) {
			return
		}
		gsap
			.to('.animation-wrapper-gsap', {
				scale: 1.1,
				duration: 3,
				ease: 'power1.out',
				yoyo: true,
				repeat: 1, // Volta ao tamanho normal
				scrollTrigger: {
					trigger: '.animation-wrapper-gsap',
					start: 'top 90%', // Quando 80% da imagem estiver visível na tela
					toggleActions: 'play none none none',
				},
			})
			.repeat(-1)

		document.addEventListener('DOMContentLoaded', () => {
			const container = document.querySelector('.animation-wrapper-gsap')
			const imageWrapper = container.querySelector('.animation-wrapper-gsap .image-wrapper')

			if (!imageWrapper) {
				return
			}
			container.addEventListener('mousemove', (e) => {
				const { width, height, left, top } = container.getBoundingClientRect()
				const x = (e.clientX - left) / width - 0.5 // Normaliza entre -0.5 e 0.5
				const y = (e.clientY - top) / height - 0.5

				gsap.to(imageWrapper, {
					rotateX: y * 15, // Inclinação vertical
					rotateY: x * 15, // Inclinação horizontal
					// scale: 1.05,
					transformPerspective: 1000,
					ease: 'power2.out',
					duration: 0.3,
				})
			})

			container.addEventListener('mouseleave', () => {
				gsap.to(imageWrapper, {
					rotateX: 0,
					rotateY: 0,
					// scale: 1,
					ease: 'power2.out',
					duration: 0.5,
				})
			})
		})
	}

	function createStaggerAnimation(container, staggerDelay = 0.2) {
		const elements = container.children

		gsap.to([...elements], {
			opacity: 1,
			y: 0,
			duration: 1,
			stagger: staggerDelay,
			ease: 'power3.out',
			scrollTrigger: {
				trigger: container,
				refreshPriority: 1,
				once: true,
				start: 'top 90%',
				toggleActions: 'play none none none',
			},
		})

		ScrollTrigger.refresh()
	}

	// sectionsAnimation()

	document.addEventListener('DOMContentLoaded', () => {
		passosSucessoHome()
		shakeOnVisible()
		porcentageBar()
	})

	// requestIdleCallback(() => {
	// 	// textoBrilha()
	// })

	document.querySelectorAll('.stagger-items-gsap').forEach((container) => {
		createStaggerAnimation(container)
	})
}
